module.exports = __webpack_public_path__ + "img/CCLF_infographic-16.eaba2720.png";